import styled from 'styled-components/macro';
import { palette } from '../../styles/constants';

export const Divider = styled.div`
    width: 1px;
    background-color: ${palette.neutral[300]};
    margin-inline: 6px;
    margin-block: -2px;
`;
